import { useEffect, useState } from 'react';
import { useTranslate } from 'react-admin';
import { Tab, Tabs } from '@mui/material';

import { DashboardContent } from 'src/layouts/dashboard';
import { CustomBreadcrumbs } from 'src/components/custom-breadcrumbs';
import { PermissionGuard } from 'src/routes/components/permission-guard';
import ErrorPage403 from 'src/pages/error/403';
import { ProviderItem, listProviders } from 'src/pages/admin/services/xbitRelayService';

import { LocksTab } from './LocksTab';
import { MismatchesTab } from './MismatchesTab';
import { XBIT_RELAY_PROVIDER_AUDIT_PERMISSION_RESOURCE } from './constants';
import './init';

type TabValue = 'mismatches' | 'locks';

const XbitRelayProviderAuditList = () => {
  const t = useTranslate();
  const [tab, setTab] = useState<TabValue>('locks');
  const [providers, setProviders] = useState<ProviderItem[]>([]);

  // Fetched once in the shell — both tabs filter by provider.
  useEffect(() => {
    listProviders()
      .then((res) => setProviders(res.data?.providers ?? []))
      .catch(() => setProviders([]));
  }, []);

  return (
    <PermissionGuard
      resource={XBIT_RELAY_PROVIDER_AUDIT_PERMISSION_RESOURCE}
      action="read"
      fallback={<ErrorPage403 />}
    >
      <DashboardContent>
        <CustomBreadcrumbs
          heading={t('module.xbitRelayProviderAudit.title')}
          links={[
            { name: t('resource.xbitRelay'), href: '#' },
            { name: t('module.xbitRelayProviderAudit.title') },
          ]}
        />

        {/* <Tabs
          value={tab}
          onChange={(_, value: TabValue) => setTab(value)}
          sx={{ mt: 2, mb: 3, borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab value="mismatches" label={t('module.xbitRelayProviderAudit.mismatchesTab')} />
          <Tab value="locks" label={t('module.xbitRelayProviderAudit.locksTab')} />
        </Tabs> */}

        {/* Only the active tab is mounted, so the two lists never fight over list params. */}
        {/* {tab === 'mismatches' && <MismatchesTab providers={providers} />} */}
        {tab === 'locks' && <LocksTab providers={providers} />}
      </DashboardContent>
    </PermissionGuard>
  );
};

export default XbitRelayProviderAuditList;
